import { render, staticRenderFns } from "./SysPortalOrgList.vue?vue&type=template&id=4bff4602&scoped=true&"
import script from "./SysPortalOrgList.vue?vue&type=script&lang=js&"
export * from "./SysPortalOrgList.vue?vue&type=script&lang=js&"
import style0 from "./SysPortalOrgList.vue?vue&type=style&index=0&id=4bff4602&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff4602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bff4602')) {
      api.createRecord('4bff4602', component.options)
    } else {
      api.reload('4bff4602', component.options)
    }
    module.hot.accept("./SysPortalOrgList.vue?vue&type=template&id=4bff4602&scoped=true&", function () {
      api.rerender('4bff4602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portal/SysPortalOrgList.vue"
export default component.exports